import { Matrix4, Vector3 } from "three";
const originMx = new Matrix4();
const projByView = new Matrix4();
const projByViewInv = new Matrix4();
const fwd = new Vector3();
function syncCamera(camera, origin, mapCamMx) {
  projByView.fromArray(mapCamMx).multiply(originMx.fromArray(origin));
  projByViewInv.copy(projByView).invert();
  updateCamera(camera, projByViewInv);
  camera.updateMatrix();
  camera.updateMatrixWorld(true);
  camera.projectionMatrix.copy(camera.matrix).premultiply(projByView);
  camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
  camera.far = calculateFar(
    camera.matrix.elements[10],
    camera.matrix.elements[14],
    camera.near
  );
  camera.userData.projByView = projByView.toArray();
  camera.userData.projByViewInv = projByViewInv.toArray();
}
const updateCamera = (target, projByViewInv2) => {
  target.position.setScalar(0).applyMatrix4(projByViewInv2);
  target.up.set(0, -1, 0).applyMatrix4(projByViewInv2).negate().add(target.position).normalize();
  fwd.set(0, 0, 1).applyMatrix4(projByViewInv2);
  target.lookAt(fwd);
};
function calculateFar(c, d, near) {
  const numerator = d * (c - 1);
  const denominator = c * near + near;
  const far = numerator / denominator;
  return far;
}
export {
  syncCamera
};
//# sourceMappingURL=main6.mjs.map
